<template>
  <table class="city-table">
    <thead>
    <tr>
      <th>{{language.name}}</th>
      <th>{{language.address}}</th>
      <th>{{language.phone}}</th>
      <th>Email</th>
      <th>{{language.on_map}}</th>
    </tr>
    </thead>
    <CitiesTableItem
        v-for="city in paginatedData"
        v-bind:key="city.id"
        v-bind:id="city.id"
        v-bind:name="city.name"
        v-bind:phone="city.phone"
        v-bind:address="city.address"
        v-bind:email="city.email"
        v-bind:city="city.city"
        v-bind:lat="city.lat"
        v-bind:lng="city.lng"
        v-bind:is_selected="city.is_selected"
    />
  </table>
  <div class="pagination" v-if="cities.length > size">
    <button v-on:click="prevPage" v-bind:disabled="pageNumber===0">
      {{language.prev}}
    </button>
    <button v-on:click="nextPage" v-bind:disabled="pageNumber >= pageCount -1">
      {{language.next}}
    </button>
  </div>
</template>

<script>

import CitiesTableItem from "@/components/CitiesTableItem";

export default {
  name: 'CitiesTable',
  props: {
    cities: Array,
    pageNumber: 0,
    language: Object
  },
  data() {
    return {
      size: 5,
      pageNumber: 0
    }
  },
  components: {
    CitiesTableItem
  },
  methods: {
    nextPage() {
      this.pageNumber++;
    },
    prevPage() {
      this.pageNumber--;
    },
  },
  computed: {
    pageCount() {
      let l = this.cities.length,
          s = this.size;
      return Math.ceil(l / s);
    },
    paginatedData() {
      const start = this.pageNumber * this.size,
          end = start + this.size;
      return this.cities.slice(start, end);
    }
  }
}
</script>

<style lang="scss" scoped>

.city-table {
  border-collapse: collapse;
  margin-top: 10px;
}

th {
  background-color: #f4f4f4 !important;
  text-align: start;
  padding: 8px
}

.pagination {
  display: flex;
  align-self: flex-end;
  margin-top: 20px;

  button {
    background-color: #075c97;
    color: white;
    font-family: "Arial", sans-serif;
    border: none;
    font-size: 14px;
    cursor: pointer;
    padding: 10px;
    outline: none;

    &:disabled {
      background-color: gray;
    }

    &:not(:last-child) {
      margin-right: 10px;
    }
  }
}

@media (max-width: 800px) {
  .city-table {
    overflow-x: scroll;
    display: block;
    width: 100%;
  }
}

</style>